import Cookies from "js-cookie";

const TokenKey = "Esp-Token";
const TokenCardIDKey = "Esp-CardID";
const UserInfoKey = "Esp-UserInfo";
const UIKey = "Esp-UIParam";
const DefaultRouter = "Esp-Default-Router";


export function getRouter() {
  return Cookies.get(DefaultRouter)
}

export function setRouter(value) {
  return Cookies.set(DefaultRouter, value)
}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

/**
 * 获取登录用户信息
 */
export function getUserInfo() {
  var data = window.localStorage.getItem(UserInfoKey);
  if (data != undefined && data != null) {
    return JSON.parse(data);
  } else {
    return {};
  }
}

/**
 * 获取默认公司
 */
export function getDefaultCorpPk() {
  var data = window.localStorage.getItem(UserInfoKey);
  if (data) {
    var user = JSON.parse(data);
    return user.pk_corp;
  } else {
    return "";
  }
}

/**
 * 保存缓存
 */
export function setLocalStorage(key, data) {
  if (key != null && key != undefined) {
    window.localStorage.setItem(key, JSON.stringify(data));
  }
}

/**
 * 获取缓存
 */
export function getLocalStorage(key) {
  var data = window.localStorage.getItem(key);
  if (data != undefined && data != null) {
    return JSON.parse(data);
  } else {
    return null;
  }
}


export function setUIParam(data) {
  if (key != null && key != undefined) {
    window.localStorage.setItem(UIKey, JSON.stringify(data));
  }
}

export function getUIParam() {
  var data = window.localStorage.getItem(UIKey);
  if (data != undefined && data != null) {
    return JSON.parse(data);
  } else {
    return {isCollapse: true};
  }
}


export function removeLocalStorage(key) {
  window.localStorage.removeItem(key);
}

// 注册权限数据
export function regAuth(data) {
  var userInfo = {
    code: data.code,
    pk: data.pk,
    name: data.name,
    pk_dept: data.pk_dept,
    pk_corp: data.pk_corp
  }
  var old = Cookies.get(TokenKey);
  if (data.token != old) {
    Cookies.set(TokenKey, data.token);
  }
  window.localStorage.setItem(UserInfoKey, JSON.stringify(userInfo))
}

export function removeAuth() {
  Cookies.remove(TokenKey);
  Cookies.remove(TokenCardIDKey);
  Cookies.remove(DefaultRouter);
  window.localStorage.removeItem(UserInfoKey);
}



// WEBPACK FOOTER //
// ./src/utils/cache.js